'use strict';

/*@ngInject*/
module.exports = function sharedService($http) {

    var emailPattern = '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?';
    var phonePattern = '(\\+[\\d]{1,3})?[\\d ]{6,16}';
    var websitePattern = '^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]@!\\$&\'\\(\\)\\*\\+,;=.]+$';

    this.getEmailPattern = function () {
        return emailPattern;
    };

    this.getPhonePattern = function () {
        return phonePattern;
    };

    this.getWebsitePattern = function () {
        return websitePattern;
    };

    this.getMapAndMapServiceUrls = function () {
        return $http.get('map/getMapAndMapServiceUrls');
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/shared.service.js
 **/